import React from 'react';

function getSessionStorageOrDefault(key, defaultValue) {
  const stored = sessionStorage.getItem(key);
  if (!stored || stored === undefined) {
    return defaultValue;
  }
  try {
    return JSON.parse(stored);
  } catch (e) {
    console.log('Error in parsing session storage', e);
    return stored;
  }
}

export default function useSessionStorage(key, defaultValue) {
  const [value, setValue] = React.useState(getSessionStorageOrDefault(key, defaultValue));
  React.useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
